/**
  * @description 获取url参数
  * @useAge getURLparmas(key)
  */
 export function getURLparmas(key:string) {
    const url=window.location.href;
    
    const temp1=url.split("?")[1] // 获取问号后面的参数 ”name=xxp&age=10“
    if(!temp1) return false
    const obj:any={}
    temp1.split("&").forEach((item)=>{
        const temp=item.split("=")
        obj[temp[0]]=temp[1]
    })
    return obj[key]
}

/** 获取token */
export function getToken(){
   const token=localStorage.getItem("token")
   return token
}